'use client';
import React from 'react';
import classNames from 'classnames';

import styled from '@benzinga/themetron';
import { Block as BlockType, ContentManager } from '@benzinga/content-manager';
import { SessionContext } from '@benzinga/session-context';

import { Block, BlockComponentProps } from '../Block';

export interface WidgetBlockProps {
  block: BlockType;
  campaigns: any;
  getBlock?: (props: BlockComponentProps) => React.ReactElement | React.ReactElement[] | null;
  type?: 'sidebar' | 'default' | 'article-bottom' | 'article-in-content';
}

export const useUpdatedWidget = (block: BlockType): BlockType => {
  const session = React.useContext(SessionContext);
  const contentManager = session.getManager(ContentManager);
  const [updatedBlock, setUpdatedBlock] = React.useState<BlockType | null>(null);

  React.useEffect(() => {
    (async () => {
      if (block.dynamic) {
        const res = await contentManager.getWordpressPost(block?.attrs?.data?.widget?.ID);
        if (res.ok) {
          setUpdatedBlock(res.ok as unknown as BlockType);
        }
      }
    })();
  }, [contentManager, block]);

  if (!block.dynamic) return block;

  return updatedBlock ?? block;
};

export const WidgetBlock: React.FC<WidgetBlockProps> = ({ block, campaigns, getBlock, type = 'default' }) => {
  const updatedWidget = useUpdatedWidget(block);
  const className = block?.attrs?.data?.className;
  return (
    <WidgetWrapper className={classNames('widget-container-wrapper', className)}>
      {Array.isArray(updatedWidget.blocks) &&
        updatedWidget.blocks.map((widget_block: BlockType, i: number) => {
          const key = `block-${widget_block?.blockName}-${i}`;
          return <Block block={widget_block} campaigns={campaigns} getBlock={getBlock} key={key} type={type} />;
        })}
    </WidgetWrapper>
  );
};

export const WidgetWrapper = styled.div`
  width: 100%;
`;
